import React, { FC } from 'react';
import FavoriteIndicator from './FavoriteIndicator';
import { PolicyTemplateTypeId } from '../../../../types/policies';
import TemplateMedia from './TemplateMedia';
import PolicyTemplateImage from '../../Images/policy_template.png';
import TemplateChips, { TemplateChipsProps } from './TemplateChips';

type Props = TemplateChipsProps & {
    name: string;
    isFavorite: boolean;
    description: string;
    type: PolicyTemplateTypeId;
};

const TemplateCard: FC<Props> = ({ name, description, isFavorite, type, spns, authTypes, protocols, risks }) => (
    <div className="group h-[371px] w-full">
        <div className="h-full w-full">
            <div className="h-[144px] overflow-hidden">
                <TemplateMedia type={type}>
                    <div className="relative w-full h-full">
                        <img
                            alt=""
                            src={PolicyTemplateImage}
                            className="relative left-[75.14px] min-w-[415.47px] resize-none rounded-[8px] rotate-[-15deg] shadow-[0px_8px_12px_0px_#0000001A]"
                        />
                        <div className="absolute top-4 left-4">
                            <FavoriteIndicator isFavorite={isFavorite} />
                        </div>
                    </div>
                </TemplateMedia>
            </div>
            <div className="py-6 px-6 flex flex-col gap-4 flex-1">
                <div className="h-[75px] flex flex-col items-start gap-1">
                    <span className="font-sf-poppins font-bold text-15 leading-[18px] tracking-[0.018rem]">{name}</span>
                    <span className="min-h-[53px] max-h-[53px] w-full font-sf text-12 font-normal leading-[18px] tracking-[0.0144rem] text-sf-gray-500 line-clamp-3">
                        {description}
                    </span>
                </div>
                <TemplateChips spns={spns} authTypes={authTypes} protocols={protocols} risks={risks} />
            </div>
        </div>
    </div>
);

export default TemplateCard;
